import { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Logo from '../SiteBoard_Logo';

const LoadingOverlay = ({message = 'loading'}) => {
  const backdropRef = useRef(null);

  useEffect(() => {
    if(typeof document.activeElement === 'object') {
      document.activeElement.blur();
    }
  }, []);

  return (
    <div 
      ref={backdropRef}  
      className='fixed flex h-screen w-screen bg-[#000000cc] top-0 left-0 justify-center items-center' 
      onClick={(event) => { if(event.target === backdropRef.current) {} }}
    >
      <div className='flex min-w-[200px] max-w-[95vw] bg-[#555] rounded-lg py-6 px-10 items-center justify-center font-semibold text-white text-[1.2em] gap-x-4 drop-shadow-[0_4px_4px_rgba(0,0,0,0.25)]'>
        <div className='animate-[spin_1s_linear_infinite]'>
          <Logo size={42} />
        </div>
        <p className='select-none'>{message}</p>
      </div>
    </div>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {}};
export default connect(mapStateToProps, {})(LoadingOverlay);
